import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { getMyOff, numberChance, numberTest, payment, startTest,isShow } from '../../../service/cTest';
import { useNavigate, Link } from "react-router-dom";

//third party
import { useSelector, useDispatch } from 'react-redux'
import { errorMessage, successMessage } from '../../../utils/toastMessage';
import { useState } from 'react';


const CTest = () => {
    const [getIsShow,setIsShow]=useState(false)
    const [getTestNumber, setTestNumber] = useState(0)
    const [getNumberChance, setNumberChance] = useState(0)
    const [getMyOfff, setMyOfff] = useState([])
    const navigate = useNavigate();
    const user = useSelector((state) => state.user)


    const handleStartTest = async () => {
        if (getTestNumber == 1) {
            navigate(`/testC/${user.value.username}`)
        }
        else {
            errorMessage("آزمونی وجود ندارد")
        }
    }

    const handleTestNumber = async () => {
        try {

            const { status, data } = await numberTest(user.value.username);
            if (status === 200) {
                setTestNumber(data.numberTest)
            }
        } catch (ex) {
        }
    }

    const handlePayment = async () => {

        try {

            const { status, data } = await payment(user.value.username);
            if (status === 200) {

                window.location.href = `https://www.newwebinar.ir/cTest/send_request/${user.value.username}`
                // window.location.href=`http://localhost:8000/cTest/send_request/${user.value.username}`
            }
            else if (status === 404) {
                errorMessage("آزمونی وجود ندارد")
            }
        } catch (ex) {
            errorMessage("آزمونی وجود ندارد")
        }
    }

    const handleNumberChance = async () => {
        try {

            const { status, data } = await numberChance(user.value.username);
            if (status === 200) {
                setNumberChance(data.number)
            }
        } catch (ex) {
        }
    }



    const handleGetMyOff = async () => {
        try {

            const { status, data } = await getMyOff(user.value.username);
            if (status === 200) {
                var  myOffId=[]
                for(var i=0;i<data.myOff.length;i++){
                    myOffId.push(data.myOff[i].off)
                }
                setMyOfff(data.off.filter(o=>myOffId.includes(o.id)))
            }
        } catch (ex) {
        }
    }

    const handleIsShow=async()=>{
        try {
            const { status, data } = await isShow();
            if (status === 200) {
                console.log(data);
                setIsShow(data.is_show)
            }
        } catch (ex) {
        }
    }



    useEffect(() => {
        handleIsShow()
    }, [])


    useEffect(() => {
        handleTestNumber()
        handleNumberChance()
        handleGetMyOff()
    },[])
    return (
        <>
            <Helmet>
                <title> حساب کاربری |   گردونه شانس   </title>
            </Helmet>
            <div className='header'>
                <h3>گردونه شانس</h3>
            </div>
            
            <div className='my-ctest' style={{display:getIsShow ? "block" : "none" }}>
                <div className='payment'>
                    <span>پرداخت مبلغ 10 هزار تومان برای شرکت در آزمون و سپس شانس آزمایی برای دریافت کد تخفیف </span>
                    <button onClick={handlePayment}>پرداخت کردن</button>
                </div>
                <hr />
                <div className='payment'>
                    <span>شانس باقی مانده برای شرکت در آزمون : {getTestNumber}</span>
                    <button onClick={handleStartTest}>شرکت در آزمون</button>
                </div>
                <hr />
                <div className='payment'>
                    <span>شانس باقی مانده برای چرخاندن گردونه : {getNumberChance}</span>
                    <button onClick={() => { navigate(`/chanceRound/${user.value.username}`) }}>چرخاندن</button>
                </div>

                <hr />
                <div className='payment'>
                    <span>کدهای تخفیف من(حداکثر 100هزار تومان)</span>
                    <span style={{textAlign:"center"}}>
                        {getMyOfff.map(o => (
                            <span>
                                <span>  {o.title} </span>
                                <span>%{o.offPercent}</span>
                                <br /> 
                            </span>
                        ))}

                    </span>
                </div>
            </div>
        </>
    )
}



export default CTest